export default __webpack_public_path__ + "static/media/tb_logo.578826fb.png";